import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteDataDictionaryShareViewRequest = {
	viewId: number;
};

export type DeleteDataDictionaryShareViewResponse = {
	sharedViewKey: string;
};

export const deleteDataDictionaryShareView = createDeleteEndpoint<
	DeleteDataDictionaryShareViewRequest,
	DeleteDataDictionaryShareViewResponse
>(({ viewId }) => `/api/v3/data-dictionary/views/${viewId}/shared-key`);
